/**
 * @desc pushLoginLog
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.SysUserLoginLogRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/loginLog/push`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
